import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AgentStatusPanel = ({ agents, onRefresh, isRefreshing }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'success';
      case 'processing': return 'warning';
      case 'error': return 'error';
      case 'idle': return 'muted-foreground';
      default: return 'muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return 'CheckCircle';
      case 'processing': return 'Loader';
      case 'error': return 'AlertCircle';
      case 'idle': return 'Clock';
      default: return 'Circle';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'active': return 'Active';
      case 'processing': return 'Processing';
      case 'error': return 'Error';
      case 'idle': return 'Idle';
      default: return 'Unknown';
    }
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Bot" size={20} className="text-muted-foreground" />
          <h3 className="text-lg font-semibold text-foreground">Agent Status</h3>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onRefresh}
          loading={isRefreshing}
          iconName="RefreshCw"
          iconPosition="left"
        >
          Refresh
        </Button>
      </div>
      <div className="space-y-3">
        {agents?.map((agent) => (
          <div
            key={agent?.id}
            className="flex items-center justify-between p-3 bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors duration-200"
          >
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
                <Icon name={agent?.icon} size={18} color="white" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground">
                  {agent?.name}
                </h4>
                <p className="text-xs text-muted-foreground">
                  Last run: {agent?.lastRun}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-2">
              <div className="flex items-center space-x-1">
                <Icon 
                  name={getStatusIcon(agent?.status)} 
                  size={14} 
                  className={`text-${getStatusColor(agent?.status)} ${agent?.status === 'processing' ? 'animate-spin' : ''}`}
                />
                <span className={`text-xs font-medium text-${getStatusColor(agent?.status)}`}>
                  {getStatusText(agent?.status)}
                </span>
              </div>
              
              {agent?.status === 'active' && agent?.progress && (
                <div className="w-12 h-2 bg-muted rounded-full overflow-hidden flex-shrink-0">
                  <div 
                    className="h-full bg-success transition-all duration-300"
                    style={{ width: `${agent?.progress}%` }}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="grid grid-cols-2 gap-4 text-center">
          <div>
            <p className="text-lg font-semibold text-foreground">
              {agents?.filter(a => a?.status === 'active')?.length}
            </p>
            <p className="text-xs text-muted-foreground">Active Agents</p>
          </div>
          <div>
            <p className="text-lg font-semibold text-foreground">
              {agents?.reduce((sum, a) => sum + (a?.dataPoints || 0), 0)?.toLocaleString()}
            </p>
            <p className="text-xs text-muted-foreground">Data Points</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentStatusPanel;